import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroBanner from './components/HeroBanner';
import MovieSection from './components/MovieSection';
import CategoryNav from './components/CategoryNav';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import { getLatestMovies, getPopularTVSeries } from '@/mocks/movies';
import { getLatestArticles } from '@/mocks/articles';

export default function Home() {
  const latestMovies = getLatestMovies(8);
  const popularTV = getPopularTVSeries(4);
  const latestArticles = getLatestArticles(6);

  return (
    <div className="min-h-screen bg-background-50">
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '成全影院 - 首页',
          description: '成全影院提供高清画质流畅播放，不卡顿蓝光体验，无广告干扰，免费在线观看电影电视剧全集。',
          url: 'https://atilol.cn/',
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              '@type': 'Question',
              name: '成全影院的影片画质如何？',
              acceptedAnswer: { '@type': 'Answer', text: '成全影院所有影片均采用高清编码技术，支持1080P全高清和4K蓝光画质。无论您是使用电脑、平板还是手机观看，都能享受到清晰细腻的视觉体验。我们采用先进的CDN加速技术，确保播放流畅不卡顿。' },
            },
            {
              '@type': 'Question',
              name: '成全影院是否需要付费？',
              acceptedAnswer: { '@type': 'Answer', text: '成全影院完全免费！您无需支付任何费用即可在线观看所有电影和电视剧全集。' },
            },
            {
              '@type': 'Question',
              name: '观看影片时会有广告吗？',
              acceptedAnswer: { '@type': 'Answer', text: '成全影院承诺无广告干扰！在观影过程中，不会出现任何插播广告、弹窗广告或贴片广告。' },
            },
            {
              '@type': 'Question',
              name: '成全影院支持哪些设备？',
              acceptedAnswer: { '@type': 'Answer', text: '成全影院支持所有主流设备，包括Windows和Mac电脑、iOS和Android手机平板、智能电视以及各种浏览器。' },
            },
            {
              '@type': 'Question',
              name: '影片更新频率是怎样的？',
              acceptedAnswer: { '@type': 'Answer', text: '成全影院每天更新最新电影和电视剧资源。通常新上映的影片会在48小时内上架。' },
            },
            {
              '@type': 'Question',
              name: '如何快速找到我想看的影片？',
              acceptedAnswer: { '@type': 'Answer', text: '您可以通过首页的推荐板块浏览精选内容，也可以使用分类功能按类型筛选（动作、喜剧、爱情、科幻、恐怖、动画、剧情、悬疑）。' },
            },
          ],
        }}
      />

      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <MovieSection
          title="最新电影"
          subtitle="精选最新上线的优质电影"
          movies={latestMovies}
          viewAllLink="/category/dongzuo"
        />
        <MovieSection
          title="热门剧集"
          subtitle="不容错过的口碑佳作"
          movies={popularTV}
          viewAllLink="/category/juqing"
        />
        <ArticleSection
          title="影视资讯"
          subtitle="最新影视动态与观影指南"
          articles={latestArticles}
        />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}